import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
import Profile from "../views/Profile.vue";
import Author from "../views/Author.vue";
// import Callback from "../components/Callback.vue";
import About from "../views/About.vue";
import { authGuard } from "../auth";
import Privacy from "../views/Privacy.vue";
import Support from "../views/Support.vue";
import Callback from "../components/Callback.vue";
import Contact from "../views/Contact.vue";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        breadcrumb: "Home"
      }
    },
    {
      path: "/author/:id",
      name: "author",
      component: Author,
      meta: {
        breadcrumb: "Author"
      }
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      beforeEnter: authGuard,
      meta: {
        breadcrumb: "Profile"
      }
    },
    {
      path: "/about",
      name: "about",
      component: About,
      meta: {
        breadcrumb: "About"
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      component: Privacy,
      meta: {
        breadcrumb: "Privacy"
      }
    },
    {
      path: "/support",
      name: "support",
      component: Support,
      meta: {
        breadcrumb: "Support"
      }
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact,
      meta: {
        breadcrumb: "Contact"
      }
    },
    {
      path: "/callback",
      name: "callback",
      component: Callback,
      meta: {
        breadcrumb: "Callback"
      }
    }
  ]
});
export default router;
